import { render, staticRenderFns } from "./AccordionGroupPorEstrategia.vue?vue&type=template&id=0452ec29&scoped=true&"
import script from "./AccordionGroupPorEstrategia.vue?vue&type=script&lang=js&"
export * from "./AccordionGroupPorEstrategia.vue?vue&type=script&lang=js&"
import style0 from "./AccordionGroupPorEstrategia.vue?vue&type=style&index=0&id=0452ec29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452ec29",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0452ec29')) {
      api.createRecord('0452ec29', component.options)
    } else {
      api.reload('0452ec29', component.options)
    }
    module.hot.accept("./AccordionGroupPorEstrategia.vue?vue&type=template&id=0452ec29&scoped=true&", function () {
      api.rerender('0452ec29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/internalTemplates/AccordionGroupPorEstrategia.vue"
export default component.exports